/* eslint-disable import/prefer-default-export */
/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';

export const QuoteContainer = styled.blockquote`
  ${({ theme, borderColor, hasBorder }) => (hasBorder && css`
      border-left: 5px solid ${borderColor};
      padding-left: ${theme.spacing(3).rem()};
    `)}
`;

export const FigcaptionContainer = styled.figcaption`
  ${({ theme }) => css`
      padding-left: ${theme.spacing(10).rem()};
    `}
`;

